import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCIt7J_upO61--SdPVXYv__D52xhg6XKnE",
    authDomain: "airy-semiotics-297902.firebaseapp.com",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);